import { styled } from '@mui/material/styles';
/**
 * Styled div to wrap each row of fields.
 * Adds bottom margin.
 */
export const FormRow = styled('div')({
    marginBottom: '1rem',
});
